<div class="close-relative" *transloco="let t">
  <div class="close-relative-header">
    <div class="title">{{ t('child/closePersons') }}</div>
    <div class="btns-right">
      <button class="btn btn-sm btn-primary btn-only-icon" (click)="addClosePerson()">
        <i class="material-symbols-rounded">add_2</i>
      </button>
    </div>
  </div>
  <div class="close-relative-content" *ngIf="closeRelatives$ | async as relatives">
    <app-child-close-relative-row
      *ngFor="let rel of relatives"
      [closeRelative]="rel"
      [childId]="child.childId"
      (refreshCloseRelative)="reloadCloseRelatives()"
    ></app-child-close-relative-row>
  </div>
</div>
